function startQismo(profile){
  console.log('start qismo');
  var prof = JSON.parse(profile);
  var appID = "wil-dwjvujkgn2eblffqj"; // Development/staging
  //var appID = "zeds-1j8qrdkfkky1yffx"; // Production
  var qismoProfile = JSON.stringify({ "user_id": prof.email, "user_name": prof.customer_code + " - " + prof.fullname });
  localStorage.setItem('qismo-widget', qismoProfile);
  var s,t; s = document.createElement('script'); s.type = 'text/javascript';
  s.src = 'https://s3-ap-southeast-1.amazonaws.com/qiscus-sdk/public/qismo/qismo-v2.js'; s.async = true;
  s.onload = s.onreadystatechange = function() { new Qismo(appID); }
  t = document.getElementsByTagName('script')[0]; t.parentNode.insertBefore(s, t);
}
